export default class Route {
    public static get DashboardRoute(): string {
        return '/app/dashboard';
    }

    public static get TPAMSReports(): string {
        return '/reports';
    }

    public static get TPAMSReportsHome(): string {
        return '/app/reports';
    }

    public static get TPAMSKbReportsRoute(): string {
        return ':period/:kBId/reports';
    }

    public static get TPAMSReportsRoute(): string {
        return '/app/reports/:period/:kBId/reports';
    }

    public static NavigateToKbReports(period: string, kBId: string): string {
        return this.TPAMSReportsRoute
            .replace(':period', period)
            .replace(':kBId', kBId);
    }

    public static TPAMSKbReports(period: string, kBId: string): string {
        return this.TPAMSKbReportsRoute
            .replace(':period', period)
            .replace(':kBId', kBId);
    }
}
